import { useState, useEffect } from "react";
import makeApiRequest from "../utils/axios.interceptors";

// Custom hook for handling API requests
const useApiRequest = (apiEndpoint, method = "GET", formData) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // For cancelling batch requests ( IF ANY )
    const abortController = new AbortController();
    const signal = abortController.signal;

    const fetchData = async () => {
      setData(null);
      try {
        const response = await makeApiRequest(apiEndpoint, method, formData, signal);

        if (response?.error?.data?.message || response?.message) {
          setError(response?.error?.data?.message || response?.message || "Seems like, something went wrong! Try again later");
          // setIsLoading(false);
          return;
        }

        if (response?.data) {
          setIsLoading(false);
        }

        setData(response?.data || null);
        setError(null);
      } catch (error) {
        console.log(error);
        if (error.name === "AbortError") {
          console.log("Request was aborted");
        }
        setError(error?.message || "Seems like, something went wrong! Try again later");
      } finally {
        // setIsLoading(false);
      }
    };

    apiEndpoint ? fetchData() : setIsLoading(false);

    // Cleanup function to abort the request when the component unmounts or a new request is initiated
    return () => {
      abortController.abort();
    };
  }, [apiEndpoint, method]);

  return { data, isLoading, error };
};

export default useApiRequest;
